/**
 * SRES · Admin Analytics dashboard (Iter98k · R8 · Feb 2026).
 *
 * Leadership-facing snapshot of fleet-wide KPIs:
 *   · Lifecycle KPI card — 90-day Win-Rate + reason breakdown
 *   · Fleet Rollback trend — cross-project safe-autofix rollbacks
 *
 * Moved off the Projects page (Round 8) so /app stays project-focused.
 */
import { Link } from "react-router-dom";
import { ChartLine, ArrowLeft } from "@phosphor-icons/react";
import ReasonAnalyticsCard from "@/pages/dashboard/ReasonAnalyticsCard";
import FleetRollbackCard from "@/pages/dashboard/FleetRollbackCard";
import SatelliteKeysGuideCard from "@/pages/admin/SatelliteKeysGuideCard";


export default function AdminAnalyticsPage() {
  return (
    <div className="max-w-6xl mx-auto px-6 py-8"
             data-testid="admin-analytics-page">
      <div className="flex items-start gap-3 mb-6">
        <div className="w-9 h-9 rounded-lg bg-brand-blue/10 flex items-center justify-center shrink-0">
          <ChartLine size={18} className="text-brand-blue" />
        </div>
        <div className="flex-1">
          <div className="text-[10.5px] uppercase tracking-[0.28em] text-slate-500">
            SRES · Leadership
          </div>
          <h1 className="font-heading font-black text-2xl tracking-tight text-slate-900 leading-tight">
            Fleet Analytics
          </h1>
          <p className="text-[12.5px] text-slate-600 mt-0.5 max-w-2xl">
            Portfolio-level lifecycle + reliability signals moved off the
            Projects landing page. Cards auto-hide when their underlying
            metric has no data.
          </p>
        </div>
        <Link to="/app"
                 className="text-[12px] text-slate-500 hover:text-brand-blue inline-flex items-center gap-1"
                 data-testid="admin-analytics-back">
          <ArrowLeft size={12} /> Projects
        </Link>
      </div>

      <div className="space-y-4">
        <ReasonAnalyticsCard />
        <FleetRollbackCard />
        <SatelliteKeysGuideCard />
      </div>
    </div>
  );
}
